import React , {useEffect} from 'react'
import useStorage from '../hooks/useStorage'
import {motion} from 'framer-motion'

function ProgressBar({file , setFile , mail}) {

    const {url , progress} = useStorage({file , mail});
    console.log(progress, url)

    useEffect(() => {
       if(url){
           setFile(null);
       }
    }, [url])
    return (
        <motion.div className="progress-bar" 
            initial={{width:0}}
            animate={{width : progress + '%'}}
        >
        </motion.div>
    )
}

export default ProgressBar
